import React from "react";
import "./Experience.css";
import Title from "../Title/Title";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/free-mode";
import {
  Navigation,
  FreeMode,
  EffectCoverflow,
  Scrollbar,
  Pagination,
} from "swiper";
import Aos from "aos";
import { useEffect } from "react";
import "aos/dist/aos.css";
function Experience() {
  useEffect(() => {
    Aos.init({ duration: 500, disable: "mobile" });
  }, []);
  return (
    <>
      <div className="contain__experience">
        <div className="experience">
          <section className="diff">
            <section className="title2">
              My skillset from my{" "}
              <span style={{ color: "indianred" }}>
                <strong>journey</strong>
              </span>{" "}
              so far <br></br> <small>Ranked from strongest to weakest</small>
            </section>
            <section className="panelskills">
              <p className="skills">
                <Swiper
                  data-aos="fade-left"
                  navigation={true}
                  scrollbar={{ clickable: true }}
                  modules={[Navigation, Scrollbar, FreeMode]}
                  className="mySwiper"
                  spaceBetween={30}
                  slidesPerView={3}
                >
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <div className="skillcolumn-noimage">SQL</div>
                      SQL (Excellent Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://powerbi.microsoft.com/pictures/shared/social/social-default-image.png"
                        alt=""
                      />{" "}
                      Microsoft Power BI (Excellent Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Microsoft_Office_Excel_%282019%E2%80%93present%29.svg/2203px-Microsoft_Office_Excel_%282019%E2%80%93present%29.svg.png"
                        alt=""
                      />{" "}
                      Microsoft Excel (Excellent Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://www.acep.org/globalassets/sites/informatics/media/article-images/gds-800x495.jpg"
                        alt=""
                      />{" "}
                      Google Data Studio (Excellent Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://www.gstatic.com/devrel-devsite/prod/vffb6f747a4a347f610c19877672b152494f6401418724d2bc2f21104794d57bc/cloud/images/favicons/onecloud/apple-icon.png"
                        alt=""
                      />{" "}
                      Google Cloud Platform (Excellent Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABcCAMAAADUMSJqAAAAY1BMVEX///9mnfZChfSuy/pim/ZWlPX3+v59qvdfmfZYlvXp8P6oyPrx9v7E2fzY5PwvffOLsvjf6f2Zu/nO3vx2pve1zfqjwvmRtvi80fvT4fyevvmCrfdsofZMi/VNkPXC1fshd/Nlb1FVAAAECElEQVRoge2ZYbuyIAyGs4CGmGlaZnmO5///ylerDTWYWJ0P73WdfQ1uHuY2YK1Wf/Zn/5GpOM7TNI9j9WFwfK7KBrSUUmuIyuyYfoqcXrQEiAYmunWy4v0dqGMjR2BaQEeX+D20cZORn72BPwsGfcefXnROXGoe3RuI4iXZWsyzO9OH5ezqWbYQAOJ5RSiTZWi1nXhbaN1cq8OhyspIw3gFAfkidjOOa9mcapKn8nMmx/wldNUMp0J0eoo41W5Hn0SG08uBbtBHd7SlpRxuLjTiqwFbV/5ALgZfVzRhAX+0cSKg5kaqzA6FLISd293OB5mxdH0OgDeWfZ0fvRtonw/3DTlcBLA7ugzXklh2GcLuywTFI/uBOjvBgl3e7YBTxJYfmNAm9ZwMa5RyM3MMqVhQ63J0DO9JZQNrySFwQumSy9MCNcBxAXul0JnixIyqKJ+XnV4UBg0z6JtRoK7ZzS6OeQnuWPurY4pjXL5TUtzMGW/ZY8uw8cI33O4ejnXDd4+Zwl++rri+WQonv4AXjjVLuq6CLNxO9eV1grHizHwejjXAm6Qx7s2ZaDz8/IBD64FjsLhrLQ/H9PNmHw4Q1XI41hdvjuKpAlS0VHozNQ+PHxUAXDnmhiemt/u15U04+Y3ckphNZyYAjse68MFr9BulWTgcg8GZf7fVMRRpPgPPb1+D6lSLoei7YMR0fmLBZeC72+cglMHK4XsL0DmksShy8P6XDcGxLPnPohLhmGbhcNy09LFXFyycGC7B8JytHPcJ0/WD4XjOeSOxY+ExB7swuMEaiBVXM287dDqVrp1h4Vil7K2BuaYd0S900LLKDYbGkyinX/R0VO8YH9ygAhLOecWe4nZYbHxwQ4chXek1x7aXi0GW+jKUUp8umMzFYizClkZ1dMELSkX7zhEzt+7aXuXtgcUeFgnt1VsRycjr06/jgauSJog5tr0CTK8J6ht0b+MEV1tiy90sfLWx9PHwJK+Los5Hfk0Gup3H+tSslkhz9+3O8siO9VbykSWDjgGU3FvBDF//X/ugV9TgDc11sYph/yGS6/U+qNtYDLtEoI0rfOtxB6xjd/Qg7e1wvxFANelQ5qYZd6n0+mZh2nfjuQJ0eTnXeRzHaWuuoCdNKrl+WJj29Kk3B12Y35u5Tz00Yodqj8uZhqXd1dd6vZS+ugT0LDtvZ7v9ekQPe9en0ax46G8h9YQe2P8+8niAexKkL2nvajn4uq4C5AkT4EXtXUZlYhp5PRm2w9fPi9o7S4pLIzX0jVwhoG/7R1U7qTkva+9Npe3mUnVP/4NpU1c5mGp/718Bnv4T7pjF9H1g9+0V+p7ru7xJ/7zu3vL977Hv2n+L3Wv/mWldvmPJx/62+7M/+6j9A6LFNFf9gydAAAAAAElFTkSuQmCC"
                        alt=""
                      />{" "}
                      Google BigQuery (Excellent Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Python_logo_and_wordmark.svg/2560px-Python_logo_and_wordmark.svg.png"
                        alt=""
                      />{" "}
                      Python (Excellent Proficiency)
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Laravel.svg/220px-Laravel.svg.png"
                        alt=""
                      />{" "}
                      Laravel (Working Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/PHP-logo.svg/220px-PHP-logo.svg.png"
                        alt=""
                      />{" "}
                      PHP (Working Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1200px-Jupyter_logo.svg.png"
                        alt=""
                      />{" "}
                      Jupyter Notebook (Working Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/220px-React-icon.svg.png"
                        alt=""
                      />{" "}
                      React.js (Working Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <div className="skillcolumn-noimage">
                        <span style={{ color: "rgb(252, 198, 3)" }}>
                          JavaScript
                        </span>
                      </div>
                      JavaScript (Working Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/4/4b/Tableau_Logo.png"
                        alt=""
                      />{" "}
                      Tableau (Working Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/10/SAS_logo_horiz.svg/2560px-SAS_logo_horiz.svg.png"
                        alt=""
                      />{" "}
                      SAS (Working Proficiency)
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="  https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Microsoft_Azure_Logo.svg/1024px-Microsoft_Azure_Logo.svg.png"
                        alt=""
                      />{" "}
                      Microsoft Azure (Working Proficiency)
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="skillcolumn">
                      <img
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/MongoDB_Logo.svg/2560px-MongoDB_Logo.svg.png"
                        alt=""
                      />{" "}
                      MongoDB (Working Proficiency)
                    </div>
                  </SwiperSlide>
                </Swiper>
              </p>
            </section>
          </section>
        </div>
      </div>

      <div className="enclosing__timeline">
        <center>
          <section className="title2">
            <h4
              style={{
                fontSize: "20px",
                color: "white",
                fontFamily: "Verdana",
                fontWeight: "200",
              }}
            >
              Reliving my{" "}
            </h4>
            <span style={{ fontSize: "48px" }}>
              <strong className="gradient__title">Experiences</strong>
            </span>
          </section>
        </center>
        <div className="timeline_true_container">
          <div className="timeline__container" data-aos="fade-up">
            <p>
              <small
                style={{
                  color: "lightgrey",
                  fontFamily: "Roboto",
                }}
              >
                2020
              </small>
              {"  "}
              <i
                class="fa fa-angle-double-left"
                style={{ fontSize: "36px" }}
              ></i>{" "}
            </p>
            <p>
              York University - BSc. Computer Science <br></br>
            </p>
            <br></br>

            <p className="responsive">
              Graduated from York University with a Bachelor of Science in
              Computer Science.
            </p>
          </div>
          <div className="timeline__container__right"></div>
          <div className="timeline__container"></div>
          <div className="timeline__container__right" data-aos="fade-up">
            <p>
              <i
                class="fa fa-angle-double-right"
                style={{ fontSize: "36px" }}
              ></i>{" "}
              <small
                style={{
                  color: "lightgrey",
                  fontFamily: "Roboto",
                }}
              >
                Software Engineer Intern at Delve Health - 2021
              </small>
              {"  "}{" "}
            </p>
            <p>
              Data Analysis <br></br>
              <small style={{ color: "lightgrey", fontFamily: "Roboto" }}>
                Utilizes: [SQL, Google Cloud Platform, Google Data Studio]
              </small>
            </p>
            <br></br>

            <p className="responsive">
              Developed 11 data dashboards using SQL, Google Data Studio, and
              the Google Cloud Platform for business operations and
              pharmaceutical clients. The data dashboards were utilized for
              conducting evaluations, identifying engagement issues, and finding
              areas that can be improved.
            </p>
          </div>
          <div className="timeline__container" data-aos="fade-up">
            <p>
              {" "}
              <small
                style={{
                  color: "lightgrey",
                  fontFamily: "Roboto",
                }}
              >
                2021 - Software Engineer Intern at Delve Health
              </small>{" "}
              <i
                class="fa fa-angle-double-left"
                style={{ fontSize: "36px" }}
              ></i>
            </p>
            <p>
              Programming <br></br>
              <small style={{ color: "lightgrey", fontFamily: "Roboto" }}>
                Utilizes: [Laravel Framework, PHP, JSON, MVC, SQL, Google Cloud
                Platform, Firebase]
              </small>
            </p>
            <p className="responsive">
              Programming tasks in this role: <br></br>Built a notification
              system for involved personnel using the Laravel framework and SQL
              that would be applied after certain conditions were met. The
              involved personnel would be provided a form to fill out, and then
              the system would store the data from the form to be later reviewed
              for relevant insights. <br></br> Built a system that gathers data
              from provided JSON files stored in an SFTP server, parses the
              files into a relevant structure, and stores them in Firebase and
              the Google Cloud Storage using the Laravel framework, SQL, and the
              Google Cloud Platform.
            </p>
          </div>
          <div className="timeline__container__right"></div>
          <div className="timeline__container"></div>
          <div className="timeline__container__right" data-aos="fade-up">
            <p>
              {" "}
              <i
                class="fa fa-angle-double-right"
                style={{ fontSize: "36px" }}
              ></i>{" "}
              <small
                style={{
                  color: "lightgrey",
                  fontFamily: "Roboto",
                }}
              >
                Software Engineer Intern at Delve Health - 2021
              </small>{" "}
            </p>
            <p>Software Validation</p>
            <p className="responsive">
              Led the software validation team in the creation and execution of
              test scripts and review of a system requirements specification
              document and a system validation plan.
            </p>
          </div>

          <div className="timeline__container"></div>
          <div className="timeline__container__right"></div>
          <div className="timeline__container" data-aos="fade-up">
            {" "}
            <p>
              {" "}
              <small
                style={{
                  color: "lightgrey",
                  fontFamily: "Roboto",
                }}
              >
                2022 - Ongoing
              </small>{" "}
              <i
                class="fa fa-angle-double-left"
                style={{ fontSize: "36px" }}
              ></i>{" "}
            </p>
            <p>
              YouTube Content Creator<br></br>
            </p>
            <p className="responsive">
              Achieved over 200,000 total views for my videos on my YouTube
              channel.
            </p>
          </div>
          <div className="timeline__container__right"></div>
          <div className="timeline__container" data-aos="fade-up"></div>
          <div className="timeline__container__right" data-aos="fade-up">
            {" "}
            <div className="timeline__container__right" data-aos="fade-up">
              <p>
                <i
                  class="fa fa-angle-double-right"
                  style={{ fontSize: "36px" }}
                ></i>{" "}
                <small
                  style={{
                    color: "lightgrey",
                    fontFamily: "Roboto",
                  }}
                >
                  2022
                </small>{" "}
              </p>
              <p>
                Microsoft Certified: Power BI Data Analyst Associate Certificate{" "}
                <br></br>
                <small style={{ color: "lightgrey", fontFamily: "Roboto" }}>
                  Links:{" "}
                  <a
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.credly.com/badges/9ae0fb93-2f6a-47d0-9d96-20796194e507/public_url"
                  >
                    Certification Details
                  </a>
                </small>
              </p>
              <p className="responsive">
                Achieved the Microsoft Certified: Power BI Data Analyst
                Associate Certificate on September 8, 2022. <br></br>
                <b>Certification Number: I406-1043</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Experience;
